import React, {useState, useEffect} from 'react';
import { useLocation, Link } from 'react-router-dom';
import { buscarLibrosDTO } from '../../services/LibrosService';
import { acortarTexto, renderStarRating,useGetWindowDimensions} from '../../utils/functions';
import Footer from '../../components/homecomponentes/footer';
import Loader from '../../components/loader';
import Barra from '../../components/barrasuperior'
import BookImage from '../../components/bookImage';
import './busquedaResultados.css';
import { useUser } from '../../context/userContext';

function ResultadosBusqueda() {
    const [libros, setLibros] = useState([]);
    const [cargando, setCargando] = useState(true);
    const location = useLocation();
    const { userData } = useUser(); // Asumiendo que userData es null o undefined

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const query = queryParams.get('query');

        if(query) {
            buscarLibrosDTO(query)
                .then(response => {
                    setLibros(response.data);
                    setCargando(false);
                })
                .catch(error => {
                    console.error('Error al buscar libros:', error);
                    setCargando(false);
                });
        }
    }, [location]);
    

  return (
    <div>
        {userData && <Barra />}
        <div className='busquedaResultados-container'>
                <h2>Resultados de búsqueda:</h2>
                {cargando ? (
                    <div style={{ marginTop:'11rem', marginBottom: '60vh'}}>
                        <Loader label={'Buscando...'}/>
                    </div>
                ) : libros.length > 0 ? (
                    <div>
                        {libros.map(libro => (
                            <div key={libro.idLibro} >
                                <LibroBusquedaItem libro={libro}/>
                            </div>
                        ))
                        }
                    </div>
                ) : (
                    <h6>No se encontraron resultados para tu búsqueda.☹️🙃</h6>
                )}
        </div>
        <Footer/>
    </div>
  )
}

function LibroBusquedaItem({libro}){

    // const autoresTexto = libro.autores.map(autor => autor.nombreAutor).join(", ");

    const GetSinopsisTextLimit = () => {
        const winWidth = useGetWindowDimensions().winWidth;
        
        switch (true) {
            case winWidth > 1000:
                return 2000;
            case winWidth > 700:
                return 560;
            case winWidth > 650:
                return 420;
            case winWidth > 620:
                return 370;
            case winWidth > 600:
                return 350;
            case winWidth > 550:
                return 380;
            case winWidth > 530:
                return 320;
            case winWidth >= 520:
                return 290;
            case winWidth >= 500:
                return 270;
            case winWidth >= 380:
                return 150;
            case winWidth >= 300:
                return 130;
            default:
                return 2000; // Define un valor por defecto o deja esta parte según tu lógica.
        }
    }
    const GetTitleTextLimit = () => {
        const winWidth = useGetWindowDimensions().winWidth;
        
        switch (true) {
            case winWidth > 600:
                return 2000;
            case winWidth > 400:
                return 40;
            case winWidth > 300:
                return 17;
            default:
                return 2000; // Define un valor por defecto o deja esta parte según tu lógica.
        }
    }
    const GetAuthorsTextLimit = () => {
        const winWidth = useGetWindowDimensions().winWidth;
        
        switch (true) {
            case winWidth > 600:
                return 2000;
            case winWidth > 300:
                return 22;
            default:
                return 2000; // Define un valor por defecto o deja esta parte según tu lógica.
        }
    }
    const GetStarsSize = () => {
        const winWidth = useGetWindowDimensions().winWidth;
        
        switch (true) {
            case winWidth > 768:
                return 24;
            case winWidth > 500:
                return 20;
            case winWidth > 380:
                return 17;
            case winWidth >= 350:
                return 14;
            default:
                return 14; // Define un valor por defecto o deja esta parte según tu lógica.
        }
    }
 
    return(
        <div>
            <Link to={`/menuestudiante/libros/${libro.idLibro}`} className='libroBusquedaItem-container'>
                <BookImage
                    src={libro.imagen}
                    alt={libro.titulo}
                    className={"libroBusquedaItem-imagen"}
                />
                <div className='libroBusquedaItem-info'>
                    <h1>{acortarTexto(libro.titulo, GetTitleTextLimit()) }</h1>
                    <p>
                    {libro.sinopsis && libro.sinopsis.trim() !== ''
                        ? acortarTexto(libro.sinopsis, GetSinopsisTextLimit())
                        : 'Sinopsis no disponible'}
                    </p>
                    <span>{acortarTexto(libro.nombreAutor, GetAuthorsTextLimit()) }</span>
                    <div className='libroBusquedaItem-estrellas'>
                        {
                            renderStarRating(libro.calificacionPromedio, GetStarsSize())
                        }
                    </div>
                </div>
            </Link>
        </div>
    )

}

export default ResultadosBusqueda;
